import React, { useState,useEffect } from 'react';
import { Button, App } from 'antd';
import { useNavigate } from 'react-router-dom';
import styles from './StoreEntryStep6.module.scss';
import { IFormDataAll } from '../../types';
import { useTranslation } from 'react-i18next';
export interface StoreEntryStep6Props {
  onNext?: (submitData: any) => void;
  onPrev?: () => void;
  onCancel?: () => void;
  storeType?: 'individual' | 'business';
  formData?: IFormDataAll;
}



// 店铺入驻第六步：First Listing Setup
const StoreEntryStep6: React.FC<StoreEntryStep6Props> = ({
  onNext,
  onPrev,
  onCancel,
  storeType = 'business', // 默认为企业类型
  formData
}) => {
  const { t, i18n } = useTranslation();
  const { message } = App.useApp();
  const navigate = useNavigate();

  // 处理添加产品
  const handleAddProduct = () => {
    // 跳转到产品发布页面
    navigate('/StorePublishProduct');
  };

  // 处理下一步
  const handleNext = () => {
    onNext && onNext({});
  };


  return (
    <div className={styles['store-entry-step6']}>
      <div className={styles['header']}>
        <div className={styles['header-title']}>{t('StoreEntryStep6.FirstSetup')}</div>
        <div className={styles['header-protection']}>
          <span className={styles['protection-icon']}>✓</span>
          {t('StoreEntryStep6.YourOut')}
        </div>
      </div>

      <div className={styles['content']}>
        <div className={styles['instruction-text']}>
          {t('StoreEntryStep6.GuideDatabase')}
        </div>

        <div className={styles['action-container']}>
          <Button
            type="primary"
            className={styles['add-product-button']}
            onClick={handleAddProduct}
          >
            {t('StoreEntryStep6.AddProduct')}
          </Button>
        </div>
      </div>

      {/* 按钮区域 */}
      <div className={styles['button-container']}>
        {/* <Button
          className={styles['back-button']}
          onClick={onPrev}
        >
          Back
        </Button> */}
        <Button
          type="primary"
          className={styles['next-button']}
          onClick={handleNext}
        >
          {t('StoreEntryStep6.Next')}
        </Button>
      </div>
    </div>
  );
};

export default StoreEntryStep6; 